import { NgModule } from '@angular/core';
import { MsAvatarComponent } from './ms-avatar.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsAvatarComponent],
	imports: [SharedLibsModule],
	exports: [MsAvatarComponent],
	providers: [],
})
export class MsAvatarModule {}
